<template>
  <footer>
    <div class="footer-links">Vers la Chapelle 54<br/>1643 Gumefens<br/><a href="https://www.google.com/maps/place/AAS+Architecture+SA/@46.678801,7.0683583,73m/data=!3m1!1e3!4m10!1m2!2m1!1sAAS+Architecture!3m6!1s0x478e63e103f13b25:0xa47abed50d5aedcc!8m2!3d46.676874!4d7.075988!15sChBBQVMgQXJjaGl0ZWN0dXJlkgEJYXJjaGl0ZWN04AEA!16s%2Fg%2F11md50byf7?entry=ttu&g_ep=EgoyMDI2MDkyNy4wIKXMDSoASAFQAw%3D%3D" target="_blank">{{ $t('plan-daccès')}}<span></span></a></div>
    <div class="footer-links">Grand-rue 24<br/>1510 Moudon</div>
    <div class="footer-links"><a href="tel:+41269152225">+41 26 915 22 25<span></span></a><a href="mailto:atelier@aas-architecture.ch">atelier@aas-architecture.ch<span></span></a></div>
    <div class="footer-links">
      <a href="javascript:void(0);" @click="openImpressum()">Impressum<span></span></a>
      <a href="javascript:void(0);" class="language-switcher" @click="switchLanguage('de')" v-if="(currentlang !== 'de')">Deutsch<span></span></a>
      <a href="javascript:void(0);" class="language-switcher" @click="switchLanguage('fr')" v-if="(currentlang !== 'fr')">Français<span></span></a>
    </div>
    <sweet-modal ref="modal">
      <h1><strong>Impressum</strong></h1>
      <div class="content">
        <div class="aas">
          <h3>{{ $t('Editeur')}}</h3>
          <p><strong>AAS Architecture SA</strong><br/>Vers la Chapelle 54<br/>CH-1643 Gumefens</p>
          <div class="links">
            <a href="tel:+41269152225">T +41 26 915 22 25<span></span></a><br/>
            <a href="mailto:atelier@aas-architecture.ch" target="_blank">atelier@aas-architecture.ch<span></span></a><br/>
            <a href="http://www.aas-architecture.ch">www.aas-architecture.ch<span></span></a>
          </div>
        </div>
        <div class="macmac">
          <h3>Webdesign</h3>
          <p><strong>macmac {{ $t('sa')}}</strong><br/>Chemin des Epinettes 5<br/>CH-1723 Marly</p>
          <div class="links">
            <a href="tel:+41265340811">T +41 26 534 08 11<span></span></a><br/>
            <a href="mailto:contact@macmac.ch" target="_blank">contact@macmac.ch<span></span></a><br/>
            <a href="http://www.macmac.ch" target="_blank">www.macmac.ch<span></span></a>
          </div>
        </div>
      </div>
    </sweet-modal>
  </footer>
</template>

<script>
import { SweetModal } from 'sweet-modal-vue';
import store from '@/store/store';

export default {
  name: 'FooterComponent',
  methods: {
    /* eslint-disable-next-line */
    switchLanguage: function(lang) {
      document.querySelector('html').setAttribute('lang', lang);
      if (this.$route.name === 'projet') {
        this.$router.push(this.translationProject);
        setTimeout(() => {
          store.commit('switchLanguage', lang);
          // window.scroll(0, 1);
        }, 300);
      } else {
        store.commit('switchLanguage', lang);
        window.scroll(0, 1);
      }
    },
    openImpressum() {
      this.$refs.modal.open();
    },
  },
  computed: {
    currentlang() {
      return store.state.i18n.locale;
    },
    translationProject() {
      if (store.state.translationProject !== '') {
        return store.state.translationProject;
      }
      return '/projets';
    },
  },
  components: {
    SweetModal,
  },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/mixins.scss';
footer {
  margin-top: 65px;
  padding: 25px 10% 35px;
  display: flex;
  .footer-links {
    width: 25%;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-start;
    &:nth-of-type(4) {
      align-items: flex-end;
    }
  }
  @include md {
    margin: 0px;
    padding: 80px 10% 10px;
    flex-wrap: wrap;
    .footer-links {
      margin-bottom: 25px;
      width: 50%;
      &:nth-of-type(4) {
        align-items: flex-start;
      }
    }
  }
  @include sm {
    padding: 65px 15% 10px 5%;
  }
  @include xs {
    padding: 50px 5% 10px 5%;
    flex-direction: column;
    .footer-links {
      margin-bottom: 15px;
      width: 100%;
    }
  }
}
// =====================================================
// Projects page special
// =====================================================
#app.projets footer {
  padding-top: 0;
  margin-left: auto;
  margin-right: auto;
  @include md {
    width: 100%;
    padding-top: 35px;
  }
  @include sm {
    padding: 45px 10% 50px 5%;
  }
  @include xs {
    padding: 20px 10% 50px 5%;
  }
}
#app.projet footer {
  @include sm {
    padding: 65px 10% 10px 5%;
  }
  @include xs {
    padding: 20px 10% 10px 5%;
  }
}
// =====================================================
// Impressum styles override
// =====================================================
footer /deep/ .sweet-modal .sweet-box-actions .sweet-action-close {
  &:hover {
    background-color: black;
  }
}
footer /deep/ .sweet-modal.is-alert .sweet-content {
  text-align: left;
  h1 {
    margin-bottom: 25px;
  }
  .content {
    display: flex;
    justify-content: space-between;
    > div {
      width: 50%;
      &:first-of-type {
        margin-right: 20px;
      }
    }
    @include sm {
      flex-direction: column;
      > div {
        width: 100%;
        &:first-of-type {
          margin-right: 0px;
          margin-bottom: 35px;
        }
      }
    }
  }
  h3 {
    margin-bottom: 10px;
  }
  a,
  p {
    font-size: 15px;
    line-height: 20px;
    @include xs {
      font-size: 14px;
      line-height: 19px;
    }
  }
  a {
    display: inline-block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Modules/FooterComponent.vue